module.exports = __webpack_public_path__ + "img/home1.7cd02f39.png";